export const faqData = [
  {
    id: 'item-1',
    question:
      'Is any prior programming experience required to enroll in this program?',
    answer:
      'Students applying should have a basic understanding of English and Mathematics, and they should go through a week-long Python primer to check if coding is for them.'
  },
  {
    id: 'item-2',
    question: 'Can I buy remaining modules if I bought DSA roadmap only?',
    answer:
      'Yes, If you only bought DSA roadmap, then also you can buy another course. Also you will get additional discount if you buy all courses together.'
  },
  {
    id: 'item-3',
    question: 'Whom to contact in case of any doubt related to the program?',
    answer:
      'You can email us at support@devsnest.in or you can contact a moderator on discord. Also, there is a channel called course-doubts on our Discord server, you can put in your query there.'
  }
]
